/**
 * Member / Product FAQ accordion
 */
(function () {
  function closeFaqItem(btn) {
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    var answer = btn.nextElementSibling;
    if (answer && answer.classList.contains('member-faq__a')) {
      answer.classList.remove('is-open');
      answer.setAttribute('hidden', '');
    }
  }

  function openFaqItem(btn, answer) {
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    if (answer) {
      answer.classList.add('is-open');
      answer.removeAttribute('hidden');
    }
  }

  function initMemberFaq(root) {
    if (!root || root.dataset.memberFaqInit === '1') return;
    root.dataset.memberFaqInit = '1';

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-member-faq-q]');
      if (!btn || !root.contains(btn)) return;

      var answer = btn.nextElementSibling;
      var isOpen = btn.classList.contains('is-open');

      root.querySelectorAll('[data-member-faq-q].is-open').forEach(function (q) {
        closeFaqItem(q);
      });

      if (!isOpen && answer && answer.classList.contains('member-faq__a')) {
        openFaqItem(btn, answer);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-member-faq]').forEach(initMemberFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
